"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loanDetailSchema = void 0;
var constants_1 = require("@hobt/constants");
// TODO: Define and add enums
exports.loanDetailSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [],
    properties: {
        approvedLenderCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 5,
            errorMessage: 'Should be a string with a maximum of 5 characters or null',
        },
        cmhcAcquiredPropertySalePriceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        dwellingTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 3,
            errorMessage: 'Should be a string with a maximum of 3 characters or null',
        },
        lenderLoanAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        loanAmortizationPeriod: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 4,
            errorMessage: 'Should be a string with a maximum of 4 characters or null',
        },
        loanApprovalDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should have date format YYYY-MM-DD or null',
        },
        loanDataExtractionTimestamp: {
            type: ['string', 'null'],
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000 or null',
        },
        loanPremiumAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        loanTermPeriod: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 4,
            errorMessage: 'Should be a string with a maximum of 4 characters or null',
        },
        loanToValueRatio: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [5, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        poolingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should have date format YYYY-MM-DD or null',
        },
        premiumChargedLoanIndicator: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1,
            errorMessage: 'Should be a string a maximum of 1 character or null',
        },
        productCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 5,
            errorMessage: 'Should be a string with a maximum of 5 characters or null',
        },
        propertyValueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        tenureTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'Should be a string with a maximum of 2 characters or null',
        },
        transactionalAppraisalModelRiskRatingTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'Should be a string with a maximum of 2 characters or null',
        },
        underwritingInterestRatePercent: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
    },
};
